import React from 'react';
import type { IconType } from 'react-icons';
import {
  TbCar,
  TbCash,
  TbChartBar,
  TbDatabase,
  TbFileDescription,
  TbFlask,
  TbGavel,
  TbMailQuestion,
  TbPencil,
  TbPill,
  TbReportMedical,
  TbStethoscope,
  TbUser,
} from 'react-icons/tb';

const ICON_MAP: Record<string, IconType> = {
  'ti-car': TbCar,
  'ti-cash': TbCash,
  'ti-chart-bar': TbChartBar,
  'ti-database': TbDatabase,
  'ti-file-description': TbFileDescription,
  'ti-flask': TbFlask,
  'ti-gavel': TbGavel,
  'ti-mail-question': TbMailQuestion,
  'ti-pencil': TbPencil,
  'ti-pill': TbPill,
  'ti-report-medical': TbReportMedical,
  'ti-stethoscope': TbStethoscope,
  'ti-user': TbUser,
};

export interface BlockIconProps {
  name: string;
  size?: number;
  color?: string;
}

export const BlockIcon = ({ name, size = 14, color }: BlockIconProps) => {
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon size={size} color={color} aria-hidden />;
};
